import { jsx as n, jsxs as u } from "react/jsx-runtime";
import { useState as A, useEffect as V } from "react";
import c from "./index10.js";
import { Form as I, textStyles as v, Input as D, Box as O, Flex as f } from "@bynder/design-system";
import { IconLockOpenSmall as L, IconLockSmall as p } from "@bynder/icons";
import { Translate as g } from "@bynder/localization";
import { getRatioBasedOnAspect as F, adjustDimensionsForAspectRatio as T } from "./index12.js";
const G = ({
  imageProperties: d,
  minimumCropValues: M,
  cropPixelProperties: r,
  onChange: C,
  aspect: m
}) => {
  const [E, x] = A({
    height: "",
    width: ""
  }), [e, h] = A({
    height: { isError: !1 },
    width: { isError: !1 }
  }), w = (i) => {
    h(i ? { ...e, [i]: { isError: !1 } } : {
      height: { isError: !1 },
      width: { isError: !1 }
    });
  };
  V(() => {
    w(), x({
      width: r.width.toFixed(0),
      height: r.height.toFixed(0)
    });
  }, [r]);
  const b = (i) => {
    const t = d.width - r.x, s = d.height - r.y;
    if (m === "custom")
      return i === "width" ? t : s;
    const o = F(m), { width: l, height: a } = T(
      d.width - r.x,
      d.height - r.y,
      o
    );
    return i === "width" ? Math.min(l, t) : Math.min(a, s);
  }, R = (i, t) => {
    const s = Number.parseFloat(i);
    if (Number.isNaN(s))
      return h((a) => ({
        ...a,
        [t]: {
          isError: !0,
          translationKey: `CROPPER_MODAL.DIMENSIONS.${t.toUpperCase()}.NUMBER_VALIDATION`
        }
      })), !1;
    const o = M[t];
    if (s < o)
      return h((a) => ({
        ...a,
        [t]: {
          isError: !0,
          translationKey: `CROPPER_MODAL.DIMENSIONS.${t.toUpperCase()}.MIN_VALIDATION`,
          boundValue: o.toFixed()
        }
      })), !1;
    const l = b(t);
    return s > Math.round(l) ? (h((a) => ({
      ...a,
      [t]: {
        isError: !0,
        translationKey: `CROPPER_MODAL.DIMENSIONS.${t.toUpperCase()}.MAX_VALIDATION`,
        boundValue: l.toFixed()
      }
    })), !1) : !0;
  }, N = (i, t) => {
    x((o) => ({
      ...o,
      [t]: i
    })), R(i, t) && (w(t), C(Number(i), t, "px"));
  };
  return /* @__PURE__ */ n(O, { children: /* @__PURE__ */ u(f, { direction: "column", gap: "4", children: [
    /* @__PURE__ */ n(H, { children: /* @__PURE__ */ n(g, { id: "CROPPER_MODAL.INSPECTOR.DIMENSIONS_LABEL" }) }),
    /* @__PURE__ */ u(f, { justifyContent: "space-between", gap: "3", children: [
      /* @__PURE__ */ u(S, { children: [
        /* @__PURE__ */ n(
          _,
          {
            value: E.width,
            onChange: (i) => N(i, "width"),
            type: "number",
            prefix: "W",
            suffix: "px",
            isInvalid: e.width.isError
          }
        ),
        e.width.isError && /* @__PURE__ */ n(I.HelperText, { isInvalid: e.width.isError, children: /* @__PURE__ */ n(
          g,
          {
            id: e.width.translationKey,
            value: e.width.boundValue || ""
          }
        ) })
      ] }),
      /* @__PURE__ */ n(f, { justifyContent: "center", children: /* @__PURE__ */ n(O, { paddingTop: "3", children: m === "custom" ? /* @__PURE__ */ n(L, {}) : /* @__PURE__ */ n(p, {}) }) }),
      /* @__PURE__ */ u(S, { children: [
        /* @__PURE__ */ n(
          B,
          {
            value: E.height,
            onChange: (i) => N(i, "height"),
            type: "number",
            prefix: "H",
            suffix: "px",
            isInvalid: e.height.isError
          }
        ),
        e.height.isError && /* @__PURE__ */ n(I.HelperText, { isInvalid: e.height.isError, children: /* @__PURE__ */ n(
          g,
          {
            id: e.height.translationKey,
            value: e.height.boundValue || ""
          }
        ) })
      ] })
    ] })
  ] }) });
}, S = c(I.Group)`
  padding: 0;
`, _ = c(D)`
  width: 114px;
  // Smaller width for prefix to allow space for 4 char input value
  :first-child {
    :first-child {
      margin-right: -3px;
    }
  }
`, B = c(D)`
  width: 114px;
`, H = c.div`
  ${v.uiTextM}
`;
export {
  G as DimensionControl
};
